import React from 'react';
import { GripHorizontal } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DragHandlePillProps {
  isVisible: boolean;
  position?: 'top' | 'floating';
  className?: string;
  onMouseDown?: (e: React.MouseEvent) => void;
}

export function DragHandlePill({ 
  isVisible, 
  position = 'top', 
  className,
  onMouseDown 
}: DragHandlePillProps) {
  if (!isVisible) return null;

  return (
    <div
      data-drag-handle="true"
      className={cn(
        'absolute left-1/2 -translate-x-1/2 z-20',
        'px-4 py-1.5',
        'bg-background/95 backdrop-blur-sm',
        'border border-border',
        'rounded-full',
        'shadow-sm',
        'cursor-grab',
        'hover:bg-muted hover:shadow-md',
        'active:cursor-grabbing',
        'transition-all duration-150',
        'opacity-0 group-hover:opacity-100',
        position === 'top' ? '-top-3' : 'top-2',
        className
      )}
      onMouseDown={onMouseDown}
    >
      {/* Three horizontal dots */}
      <div className="flex items-center gap-1">
        <div className="w-1 h-1 rounded-full bg-muted-foreground/50" />
        <div className="w-1 h-1 rounded-full bg-muted-foreground/50" />
        <div className="w-1 h-1 rounded-full bg-muted-foreground/50" />
        <div className="w-1 h-1 rounded-full bg-muted-foreground/50" />
        <div className="w-1 h-1 rounded-full bg-muted-foreground/50" />
      </div>
    </div>
  );
}
